<template>
	<transition name="modal">
		<div class="modal modal-overlay" :key="elKey" :style="overlay_style">
			<!-- </div> @click.self="$emit('close')"> -->
			<div class="modal-window" ref="draggableContainer" id="draggable-container">
				<div class="modal-header" @mousedown="dragMouseDown" id="draggable-header">
					<slot name="title"></slot>
					<p v-if="showCloseButton" style="float: right;padding-right:10px;color:yellow;font-weight: normal;font-size: 13px;"><a href="javascript:;" @click="$emit('close')">Close</a></p>
				</div>
				<div ref="modalContent" class="modal-content">
					<slot name="body"></slot>
				</div>
				<!-- <footer class="modal-footer">
					<slot name="footer">
						<button @click="$emit('close')">닫기</button>
					</slot>
				</footer> -->
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data: function() {
		return {
			positions: {
				clientX: undefined,
				clientY: undefined,
				movementX: 0,
				movementY: 0,
			},
			elKey: 0,
		};
	},
	props: {
		modalWidth: Number,
		showCloseButton: {
			type: Boolean,
			default: true,
		},
		// #3320: 배경 어둡기(0~1). 지정하지 않으면 style 을 만들지 않아 기존 rgba(0, 0, 0, 0.5) 가 그대로 적용된다.
		overlayOpacity: {
			type: Number,
			default: null,
		},
	},
	computed: {
		overlay_style() {
			if (this.overlayOpacity == null) return null;
			return { background: 'rgba(0, 0, 0, ' + this.overlayOpacity + ')' };
		},
	},
	watch: {
		modalWidth: {
			// immediate: true, // => modalWidth가 바뀌는 경우에만 update되도록
			handler() {
				if (this.modalWidth) {
					this.setModalWidth();
				} else this.elKey++;
			},
		},
	},
	methods: {
		dragMouseDown: function(event) {
			event.preventDefault();
			// get the mouse cursor position at startup:
			this.positions.clientX = event.clientX;
			this.positions.clientY = event.clientY;
			document.onmousemove = this.elementDrag;
			document.onmouseup = this.closeDragElement;
		},
		elementDrag: function(event) {
			event.preventDefault();
			this.positions.movementX = this.positions.clientX - event.clientX;
			this.positions.movementY = this.positions.clientY - event.clientY;
			this.positions.clientX = event.clientX;
			this.positions.clientY = event.clientY;
			const container = this.$refs.draggableContainer;
			let next_top = container.offsetTop - this.positions.movementY;
			let next_left = container.offsetLeft - this.positions.movementX;
			// 헤더가 항상 일부 보이도록 드래그 범위 제한 (Close 버튼 접근 보장)
			const min_visible = 40;
			const max_top = window.innerHeight - min_visible;
			const max_left = window.innerWidth - min_visible;
			const min_top = min_visible - container.offsetHeight;
			const min_left = min_visible - container.offsetWidth;
			if (next_top > max_top) next_top = max_top;
			if (next_top < min_top) next_top = min_top;
			if (next_left > max_left) next_left = max_left;
			if (next_left < min_left) next_left = min_left;
			container.style.top = next_top + 'px';
			container.style.left = next_left + 'px';
		},
		closeDragElement() {
			document.onmouseup = null;
			document.onmousemove = null;
		},
		setModalWidth() {
			this.$nextTick(() => {
				if (this.$refs.modalContent) this.$refs.modalContent.firstChild.style['width'] = (window.innerWidth * this.modalWidth) / 100 + 'px';
			});
		},
	},
	created() {
		if (this.modalWidth) this.setModalWidth();
	},
};
</script>

<style lang="scss" scoped>
.modal {
	&.modal-overlay {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		z-index: 30;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
	}
	&-window {
		background: #fff;
		border-radius: 4px;
		overflow: hidden;
		max-width: 100vw;
		max-height: 100vh;
		display: flex;
		flex-direction: column;
	}
	&-header {
		color: #fff;
		font-weight: bold;
		font-size: 15px;
		line-height: 32px;
		padding: 0 0 0 12px;
		margin-bottom: 0px !important;
		background: #2267bb;
		flex: 0 0 auto;
		//padding: 10px 10px 0px 10px;
	}
	&-content {
		padding: 5px 10px 0px 10px;
		overflow: auto;
		flex: 1 1 auto;
		min-height: 0;
	}
	&-footer {
		background: #ccc;
		padding: 10px 0px 0px 0px;
		text-align: right;
	}
}

#draggable-container {
	position: absolute;
	z-index: 9;
}
#draggable-header {
	z-index: 10;
}
// .modal-enter-active,
// .modal-leave-active {
// 	transition: opacity 0.1s;
// 	.modal-window {
// 		transition: opacity 0.1s, transform 0.1s;
// 	}
// }
// .modal-leave-active {
// 	transition: opacity 0.1s ease 0.1s;
// }
// .modal-enter,
// .modal-leave-to {
// 	opacity: 0;
// 	.modal-window {
// 		opacity: 0;
// 		transform: translateY(-20px);
// 	}
// }
</style>
